import React from 'react';
import PropTypes from 'prop-types';

const Heart = ({ fill = '#000', width, style }) => (
  <svg
    width={width}
    style={style}
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.294 7.655a4.376 4.376 0 0 0 1.373-3.17c0-1.147-.46-2.295-1.373-3.17A4.746 4.746 0 0 0 12.509.029C11.142-.118 9.721.31 8.672 1.315l-.005.005-.006-.005A4.778 4.778 0 0 0 5.351 0C4.152 0 2.954.44 2.04 1.315a4.347 4.347 0 0 0 0 6.34L8.667 14l6.627-6.345Z"
      fill={fill}
    />
  </svg>
);

Heart.defaultProps = {
  fill: '#000',
  width: '13px',
  style: undefined,
};

Heart.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  style: PropTypes.object,
};

export default Heart;
